<template>
  <div class="row q-gutter-sm">
    <div
      class="col row"
    >
      <q-chip
        v-for="orderItem in props.expand ? orderItems : orderItems.slice(0, props.col.limitValues)"
        :key="orderItem.id"
        style="max-width: 150px;"
        class="col-auto"
        square
        :color="color(orderItem)"
        :text-color="textColor(orderItem)"
        :label="orderItem.description || (orderItem.type ? $_.startCase(orderItem.type) : '<unknown>')"
        :title="orderItem.description || (orderItem.type ? $_.startCase(orderItem.type) : '<unknown>')"
      />
    </div>
    <q-btn
      v-if="props.expand && orderItems.length > props.col.limitValues"
      class="col-auto"
      icon="unfold_less"
      size="sm"
      @click.stop="props.expand = false"
    />
    <q-btn
      v-else-if="!props.expand && props.col.limitValues < orderItems.length"
      class="col-auto"
      icon="unfold_more"
      size="sm"
      @click.stop="props.expand = true"
    />
  </div>
</template>

<script>

export default {
  name: 'OrderItemsCell',
  props: {
    props: {
      type: Object,
      required: true
    }
  },
  computed: {
    orderItems () {
      return this.props.row.orderItems.data
    }
  },
  methods: {
    color (orderItem) {
      if (orderItem.state === 'draft') {
        return 'grey-4'
      }
      if (orderItem.state === 'voided') {
        return 'red-3'
      }

      if (orderItem.type === 'ticket') {
        return 'indigo-3'
      } else if (orderItem.type === 'item') {
        return 'green-3'
      } else if (orderItem.type === 'membership-interval') {
        return 'blue-grey-3'
      } else if (orderItem.type === 'day-pass') {
        return 'blue-grey-3'
      } else {
        return null
      }
    },
    exportString (row) {
      return _.map(row.orderItems.data, orderItem => `${orderItem.description || (orderItem.type ? _.startCase(orderItem.type) : '<unknown>')}`).join('\n')
    },
    textColor (orderItem) {
      if (orderItem.state === 'draft') {
        return 'grey'
      }
      if (orderItem.state === 'voided') {
        return 'grey-6'
      }

      return 'dark'
    }
  }
}

</script>
